export default __webpack_public_path__ + "static/media/interrogation.5ad1eafd.png";